import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { NgForm } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-nivel-servico',
  templateUrl: './nivel-servico.component.html',
  styleUrls: ['./nivel-servico.component.css']
})
export class NivelServicoComponent implements OnInit {

  constructor(public svc: AppService, private tl: TranslateService) { 
    //Carrega as Traduções Gerais da Tela
    this.svc.sbGetTraducaoAuto("geral.mensagens").subscribe((resp) => {
      this.traducaoGeral = resp;
    });
  }

  public traducaoGeral: any;

  public fl_n1: boolean = false;
  public fl_n2: boolean = false;
  public fl_n3: boolean = false;
  public fl_1: boolean = false;
  public fl_2: boolean = false;
  public fl_3: boolean = false;

  public spinFiltro = false;

  public n1: any = {
    ordem: -1,
    id_nivel_acesso: -1,
    titulo: "",
    operador: "",
    dias: "",
    legenda: ""  
  };

  public n2: any = {
    ordem: -1,
    id_nivel_acesso: -1,
    titulo: "",
    operador: "",
    dias: "",
    legenda: ""  
  };

  public n3: any = {
    ordem: -1,
    id_nivel_acesso: -1,
    titulo: "",
    operador: "",
    dias: "",
    legenda: ""  
  };

  public limpar(nivel: number): void{
    switch(nivel){
      case 1:
        this.n1 = {
          ordem: -1,
          id_nivel_acesso: -1,
          titulo: "",
          operador: "",
          dias: "",
          legenda: ""  
        };
        break;
      case 2:
        this.n2 = {
          ordem: -1,
          id_nivel_acesso: -1,
          titulo: "",
          operador: "",
          dias: "",
          legenda: ""  
        };
        break;
      case 3:
        this.n3 = {
          ordem: -1,
          id_nivel_acesso: -1,
          titulo: "",
          operador: "",
          dias: "",
          legenda: ""  
        };
        break;
    }
  }

  public trocarOperador(nivel: number): void {
    switch(nivel){
      case 1:
        if (this.n1.operador == "no_dia"){
          this.n1.dias = "0";
          this.fl_n1 = true;        
        } else {
          this.n1.dias = "";
          this.fl_n1 = false; 
        }
        break;
      case 2:
        if (this.n2.operador == "no_dia"){
          this.n2.dias = "0";
          this.fl_n2 = true;
        } else {
          this.n2.dias = "";
          this.fl_n2 = false; 
        }
        break;
      case 3:
        if (this.n3.operador == "no_dia"){
          this.n3.dias = "0";
          this.fl_n3 = true;
        } else {
          this.n3.dias = "";
          this.fl_n3 = false;
        }
        break;
    }
  }

  public sbProcessarNiveis(f: NgForm){
    try {
      if (f.valid) {
        var lista: any = {};
        lista.lista_servicos = [];

        this.n1.ordem = 1;
        this.n2.ordem = 2;
        this.n3.ordem = 3;

        if (this.fl_1) { lista.lista_servicos.push(this.n1) };
        if (this.fl_2) { lista.lista_servicos.push(this.n2) };
        if (this.fl_3) { lista.lista_servicos.push(this.n3) };

        this.spinFiltro = true;
        this.svc.NiveisServicoAlterar(lista);
        this.svc.NiveisServicoAlterado().subscribe((resp) => {
          if (resp == false) this.spinFiltro = false;
          else if (resp != null) {
            this.spinFiltro = false;
            this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("niveis_servico.mensagens.nivel_atualizado"));
          }
        });
        
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", this.traducaoGeral.atencao, this.traducaoGeral.campos_obrigatorios);
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarFiltros() {
    try {
      this.spinFiltro = true;
      this.svc.NiveisServicoPesquisar();
      this.svc.NiveisServicoEncontrado().subscribe((resp) => {
        if (resp == false) this.spinFiltro = false; 
        else if (resp != null) {
          this.spinFiltro = false;
          if (resp.lista_servicos.length >= 1) { this.n1 = resp.lista_servicos[0]; this.fl_1 = true; }
          if (resp.lista_servicos.length >= 2) { this.n2 = resp.lista_servicos[1]; this.fl_2 = true; }
          if (resp.lista_servicos.length >= 3) { this.n3 = resp.lista_servicos[2]; this.fl_3 = true; }
        }
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  ngOnInit() {
    this.carregarFiltros();
  }

}
